import { lazy } from 'react';
import { Permission, KNOWN_SLOTS, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Manifest: Clipboard-Erfassung (Paket F, Issue #83).
 *
 * Skill registriert einen globalen Hotkey (Strg/Cmd+Shift+V) auf der
 * ProjectDetail-Seite. Inhalt der Zwischenablage (Text oder Bild) wird in
 * einem Modal vorgezeigt und auf Wunsch als InputArtifact gespeichert.
 *
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass der Capture-Host erst lädt, wenn die Projekt-Detailseite rendert.
 */
export const inputClipboardCaptureManifest: SkillManifest = {
  key: 'input-clipboard-capture',
  name: 'Clipboard-Erfassung',
  description: 'Strg+Shift+V im Projekt-Kontext speichert Zwischenablage als Input-Eintrag.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

const ClipboardCaptureHost = lazy(() =>
  import('./ClipboardCaptureHost').then((m) => ({ default: m.ClipboardCaptureHost })),
);

export const inputClipboardCaptureSkill: FrontendSkill = {
  manifest: inputClipboardCaptureManifest,
  slots: {
    [KNOWN_SLOTS.PROJECT_DETAIL_COCKPIT_BELOW]: [
      {
        key: 'clipboard-capture',
        order: 50,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId+readOnly
        render: ClipboardCaptureHost,
      },
    ],
  },
};
